<template>
    <div class="min-h-screen bg-gray-900 text-white py-3 px-2 sm:py-6 sm:px-4 lg:px-8">
        <div class="max-w-7xl mx-auto">
            <DataListControls v-model:searchText="searchText" v-model:pageSize="pageSize"
                v-model:currentPage="currentPage" collectionName="messages" @dataUpdate="handleDataUpdate">
                <template #actions>
                    <button v-show="false" @click="openAddForm"
                        class="inline-flex items-center px-3 py-2.5 sm:px-4 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 min-h-[44px] touch-manipulation">
                        Add message
                    </button>
                </template>
                <template #table>
                    <div class="overflow-x-auto -mx-2 sm:mx-0">
                        <table class="min-w-full divide-y divide-gray-700">
                            <thead class="bg-gray-800">
                                <tr>
                                    <th
                                        class="px-2 sm:px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider">
                                        Action</th>
                                    <th
                                        class="px-2 sm:px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider">
                                        Name</th>
                                    <th
                                        class="px-2 sm:px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider hidden md:table-cell">
                                        Phone</th>
                                    <th
                                        class="px-2 sm:px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider hidden lg:table-cell">
                                        Email</th>
                                    <th
                                        class="px-2 sm:px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider hidden xl:table-cell">
                                        Message</th>
                                    <th
                                        class="px-2 sm:px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider hidden lg:table-cell">
                                        Created At</th>
                                    <th
                                        class="px-2 sm:px-6 py-3 text-left text-xs font-medium text-gray-200 uppercase tracking-wider hidden sm:table-cell">
                                        Status</th>
                                </tr>
                            </thead>
                            <tbody class="bg-gray-700 divide-y divide-gray-600">
                                <tr v-for="message in messages" :key="message.id" class="hover:bg-gray-600">
                                    <td class="px-2 sm:px-6 py-3 sm:py-4 whitespace-nowrap text-sm font-medium relative">
                                        <div class="relative inline-block text-left dropdown-container">
                                            <button @click="toggleDropdown(message.id)"
                                                class="inline-flex items-center justify-center w-10 h-10 sm:w-8 sm:h-8 bg-gray-600 bg-opacity-50 hover:bg-opacity-75 rounded-full transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 touch-manipulation">
                                                <svg class="w-4 h-4 text-gray-300" fill="currentColor"
                                                    viewBox="0 0 20 20">
                                                    <path
                                                        d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                                                </svg>
                                            </button>

                                            <div v-if="openDropdownId === message.id"
                                                class="absolute left-0 top-0 mt-10 w-40 bg-gray-800 bg-opacity-95 backdrop-blur-sm border border-gray-600 rounded-lg shadow-lg z-50">
                                                <div class="py-1">

                                                    <button @click="openDeleteDialog(message); closeDropdown()"
                                                        class="w-full text-left px-4 py-2 text-sm text-red-400 hover:bg-red-600 hover:bg-opacity-20 hover:text-red-300 transition-all duration-200 flex items-center">
                                                        <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor"
                                                            viewBox="0 0 24 24">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2"
                                                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                        </svg>
                                                        Delete
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="px-2 sm:px-6 py-3 sm:py-4 text-gray-300 max-w-xs truncate text-sm sm:text-base">{{ message.name || 'N/A' }}
                                    </td>
                                    <td class="px-2 sm:px-6 py-3 sm:py-4 text-gray-300 max-w-xs truncate hidden md:table-cell">{{ message.phone || 'N/A' }}
                                    </td>
                                    <td class="px-2 sm:px-6 py-3 sm:py-4 text-gray-300 max-w-xs truncate hidden lg:table-cell">{{ message.email || 'N/A' }}
                                    </td>
                                    <td class="px-2 sm:px-6 py-3 sm:py-4 text-gray-300 max-w-xs truncate hidden xl:table-cell">{{ message.message || 'N/A' }}
                                    </td>
                                    <td class="px-2 sm:px-6 py-3 sm:py-4 whitespace-nowrap text-white text-xs sm:text-sm hidden lg:table-cell">
                                        {{ message.createdAt?.toDate()?.toLocaleString() || 'N/A' }}
                                    </td>
                                    <td class="px-2 sm:px-6 py-3 sm:py-4 whitespace-nowrap hidden sm:table-cell">
                                        <label class="relative inline-flex items-center cursor-pointer">
                                            <input type="checkbox" :checked="message.status"
                                                @change="toggleStatus(message)" class="sr-only peer"
                                                :disabled="updatingStatus === message.id">
                                            <div
                                                class="w-11 h-6 bg-gray-600 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-800 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600">
                                            </div>
                                            <span class="ml-3 text-sm font-medium"
                                                :class="message.status ? 'text-green-400' : 'text-gray-400'">
                                                {{ message.status ? 'Active' : 'Inactive' }}
                                            </span>
                                        </label>
                                    </td>
                                </tr>
                                <tr v-if="!messages.length && !isLoading" class="bg-gray-700">
                                    <td colspan="2" class="px-2 sm:px-6 py-4 text-center text-gray-400 sm:hidden">
                                        No data found.
                                    </td>
                                    <td colspan="7" class="px-6 py-4 text-center text-gray-400 hidden sm:table-cell">
                                        No data found.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </DataListControls>

            <DeleteConfirmation :isVisible="showDeleteDialog" :deleteId="selectedMessageId"
                :elementName="selectedMessageName" elementCategory="Message" collectionName="messages"
                :isLastRecordOnPage="isLastRecordOnPage" @onEmitHandleEvent="handleDeleteEvent" />
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { doc, updateDoc } from 'firebase/firestore';
import { projectFirestore } from '@/firebase/config';
import DataListControls from '@/components/DataListControls.vue';
import DeleteConfirmation from '@/components/DeleteConfirmation.vue';

const searchText = ref('');
const pageSize = ref(10);
const currentPage = ref(1);
const messages = ref([]);
const showDeleteDialog = ref(false);
const selectedMessageId = ref(null);
const selectedMessageName = ref('');
const isLoading = ref(false);
const openDropdownId = ref(null);
const updatingStatus = ref(null);

const isLastRecordOnPage = computed(() => {
    return messages.value.length === 1 && currentPage.value > 1;
});


const handleDataUpdate = (data) => {
    messages.value = data;
    isLoading.value = false;
};

const openAddForm = () => {
    selectedMessageId.value = null;
    alert('Message creation form not implemented.');
};

const openEditForm = (message) => {
    selectedMessageId.value = message.id;
    alert('Message edit form not implemented.');
};

const openDeleteDialog = (message) => {
    selectedMessageId.value = message.id;
    selectedMessageName.value = message.name || 'Unnamed Message';
    showDeleteDialog.value = true;
};

const toggleDropdown = (messageId) => {
    openDropdownId.value = openDropdownId.value === messageId ? null : messageId;
};

const closeDropdown = () => {
    openDropdownId.value = null;
};

const toggleStatus = async (message) => {
    try {
        updatingStatus.value = message.id;
        const newStatus = !message.status;

        // Update in Firestore
        const messageRef = doc(projectFirestore, 'messages', message.id);
        await updateDoc(messageRef, {
            status: newStatus
        });

        // Update local state
        const messageIndex = messages.value.findIndex(m => m.id === message.id);
        if (messageIndex !== -1) {
            messages.value[messageIndex].status = newStatus;
        }

        console.log(`message ${message.title} status updated to: ${newStatus ? 'Active' : 'Inactive'}`);
    } catch (error) {
        console.error('Error updating message status:', error);
        alert(`Failed to update message status: ${error.message}`);
    } finally {
        updatingStatus.value = null;
    }
};


const handleDeleteEvent = (event, hasError = false, message = '') => {
    if (event === 'close') {
        showDeleteDialog.value = false;
    } else if (event === 'deleted') {
        showDeleteDialog.value = false;
        if (isLastRecordOnPage.value) {
            currentPage.value = Math.max(1, currentPage.value - 1);
        }
    } else if (event === 'error') {
        console.error('Delete error:', message);
        alert(`Failed to delete message: ${message}`);
    }
};
</script>

<style scoped>
tr {
    transition: background-color 0.2s ease;
}

button {
    transition: color 0.2s ease, background-color 0.2s ease;
}

.touch-manipulation {
    touch-action: manipulation;
}
</style>